import React, { Component, } from "react";
// import {Navbar,Nav,NavDropdown,Form,FormControl} from "react-bootstrap"
import { Navbar, Nav, NavDropdown, Dropdown } from "react-bootstrap";

import { logo } from "./logo";

import Description from "../../containers/Description/Description";
import DownloadPage from "../../containers/DownloadPage/DownloadPage";

import "./style.css";
import ModalView from "../ModalView/ModalView";

import Hash from "../../containers/Hash/Hash";
import VerifySign from "../../containers/VerifySign/VerifySign";
import VerifyCert from "../../containers/VerifyCert/VerifyCert";
import CreateSign from "../../containers/CreateSign/CreateSign";
import GenPrivKey from "../../containers/Key/GenPrivKey/GenPrivKey";
import GenReq from "../../containers/GenReq/GenReq";
import CreateCert from "../../containers/CreateCert/CreateCert";
import Encryption from "../../containers/Encryption/Encryption";
import Decryption from "../../containers/Decription/Decription";
import GenEncryptKeyView from "../../containers/Key/GenEncryptKey/GenEncryptKeyView";
import KeyProtectView from "../../containers/Key/KeyProtect/KeyProtectView";
import KeyUnprotectView from "../../containers/Key/KeyUnprotect/KeyUnprotectView";
import Mac from "../../containers/CreateMac/Mac";
import Hmac from "../../containers/CreateHmac/Hmac";
import CreateToken from "../../containers/Token/CreateToken/CreateToken";
import DecodeToken from "../../containers/Token/DecodeToken/DecodeToken";
import SetPrivateKeyView from "../../containers/Key/SetPrivateKey/SetPrivateKeyView";
import CreateCRL from "../../containers/CRL/CreateCRL/CreateCRL";
import VerifyCRL from "../../containers/CRL/VerifyCRL/VerifyCRL";

const noticeStyle = {
  content: {
    top: "50%",
    left: "10%",
    right: "10%",
    bottom: "auto",
    borderColor: "rgba(204, 204, 204,0)",
    transform: "translate(0, -50%)",
    boxShadow: "0 14px 28px #00000073",
    borderRadius: "20px",
    backgroundColor: "black",
    position: "absolute",
    zIndex: "3",
    animation: "fadeIn 1s",
  },
  overlay: {
    background: "#0000004d",
  },
};

const customStyleforCertSign = {
  content: {
    top: "50%",
    left: "50%",
    right: "5%",
    bottom: "auto",
    maxHeight: "90%",
    borderColor: "rgba(204, 204, 204,0)",
    transform: "translate(-50%, -50%)",
    boxShadow: "0 14px 28px #00000073",
    borderRadius: "20px",
    backgroundColor: "black",
    position: "absolute",
    zIndex: "3",
    animation: "fadeIn 1s",
  },
  overlay: {
    background: "#0000004d",
  },
};

class Header extends Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      idView: "view",
      viewName: "",
      isOpenDescription: true,
      isOpenDownloadPage: false

    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openDescription = this.openDescription.bind(this);
    this.openDownloadPage = this.openDownloadPage.bind(this);
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      Modal.setAppElement("#wrapper");
    }
  }

  displaying(elId, opacity, transition) {
    // document.getElementById(elId).style.opacity = opacity;
    // document.getElementById(elId).style.transition = transition;
  }

  openModal(viewName) {
    setTimeout(() => {
      this.setState({ viewName: viewName, modalIsOpen: true });
    }, 500);
    this.displaying("header", "1", "1s");
  }
  closeModal() {
    this.displaying(this.state.idView, "0", "0.5s");
    this.setState({
      modalIsOpen: false,
      idView: "view",
      viewName: "",

      dataHash: {
        ...this.state.dataHash,
        belt_hash: "",
        bash512: "",
        bash384: "",
        bash256: "",
      },

      dataSign: { ...this.state.dataSign, statusSign: "" },
      dataCert: { ...this.state.dataCert, statusCert: "" },
    });

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.displaying("header", "1", "0.5s");
  }


  componentDidMount() {
    if (window.location.hash === '#download') {
      this.openDownloadPage()
    }

    if (window.location.hash === '#description') {
      this.openDescription()
    }
  }

  openDescription() {
    this.setState({ isOpenDescription: true })
    this.setState({ isOpenDownloadPage: false })

  }

  openDownloadPage() {
    this.setState({ isOpenDownloadPage: true })
    this.setState({ isOpenDescription: false })
  }
  render() {
    return (
      <header id="header">
        <div className="logo">
          <span className="icon ">{logo}</span>
        </div>

        <div className="content">
          <div className="inner">
            <h1>LWOCRYPT</h1>
            <p>
              тестовая среда криптографических алгоритмов
              {/* <br />
              for free under the Creative Commons license. */}
            </p>
          </div>
        </div>


        <nav>
          <ul>
            {
              window.location.pathname !== '/' &&
              <li>
                <Navbar expand="md">
                  <Nav>
                    <Nav.Link
                      href="/"
                      style={{ backgroundColor: this.state.isOpenDescription && "grey" }}
                    >
                      Назад
                    </Nav.Link>
                  </Nav>
                </Navbar>
              </li>
            }
            {
              window.location.pathname === '/' &&
              <React.Fragment>
                <li>
                  <Navbar expand="md">
                    <Nav>
                      <Nav.Link
                        onClick={this.openDescription}
                        href="#description"
                        style={{ backgroundColor: this.state.isOpenDescription && "grey" }}
                      >
                        Описание
                      </Nav.Link>
                    </Nav>
                  </Navbar>
                </li>
                <li>
                  <Navbar expand="md" >
                    <Nav>
                      <Nav.Link
                        onClick={this.openDownloadPage}
                        style={{ backgroundColor: this.state.isOpenDownloadPage && "grey" }}
                        href="#download">
                        Скачать
                      </Nav.Link>
                    </Nav>
                  </Navbar>
                </li>
              </React.Fragment>
            }
            <li>
              <Navbar expand="md" >
                <NavDropdown title="Криптография" drop="down">
                  <Nav className="nav-kuznechik">
                    <Nav.Link
                      href="/cryptokuznechik"
                      style={{ color: "black", width: '100%' }}
                    >
                      Кузнечик (шифр)
                    </Nav.Link>
                  </Nav>
                  <Nav className="nav-hash">
                    <Nav.Link
                      onClick={() => this.openModal("Hash")}
                      href="#hash"
                      style={{ color: "black", width: '100%' }}
                    >
                      Хэширование
                    </Nav.Link>
                  </Nav>
                  <Nav className="nav-mac">
                    <Nav.Link
                      onClick={() => this.openModal("Mac")}
                      href="#Mac"
                      style={{ color: "black", width: '100%' }}
                    >
                      Имитовставка(Mac)
                    </Nav.Link>
                  </Nav>
                  <Dropdown
                    drop="right">
                    <NavDropdown
                      title="СОС"
                    >
                      <NavDropdown.Item
                        onClick={() => this.openModal("CreateCRL")}
                        href="#genprivkey"
                      >
                        &bull; Создание СОС
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#genprivkey"
                        onClick={() => this.openModal("VerifyCRL")}
                      >
                        &bull; Проверка СОС
                      </NavDropdown.Item>

                    </NavDropdown>
                  </Dropdown>
                  {/* <Dropdown
                    drop="right">
                    <NavDropdown
                      title="СОК"
                    >
                      <NavDropdown.Item
                        onClick={this.props.openCRLModal}
                        href="#genprivkey"
                      >
                        &bull; Создание СОК
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#genprivkey"
                        onClick={this.props.openGenEncryptKeyViewModal}
                      >
                        &bull; Проверка СОК
                      </NavDropdown.Item>

                    </NavDropdown>
                  </Dropdown> */}
                  <Dropdown
                    drop="right">
                    <NavDropdown
                      title="Ключи"
                    >
                      <NavDropdown.Item
                        onClick={() => this.openModal("GenPrivKey")}
                        href="#genprivkey"
                      >
                        &bull; Генерация личного ключа
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#genprivkey"
                        onClick={() => this.openModal("GenEncryptKeyView")}
                      >
                        &bull; Генерация 32байтового ключа
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        onClick={() => this.openModal("SetPrivateKeyView")}
                        href="#setprivatekey"
                      >
                        &bull;  Установка личного ключа в токен
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#keyprotect"
                        onClick={() => this.openModal("KeyProtectView")}
                      >
                        &bull; Установка защиты на личный ключ
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        href="#keyunprotect"
                        onClick={() => this.openModal("KeyUnprotectView")}
                      >
                        &bull; Снятие защиты с личного ключа
                      </NavDropdown.Item>
                    </NavDropdown>
                  </Dropdown>
                  <Dropdown
                    drop="right">
                    <NavDropdown title="Сертификат" >
                      <NavDropdown.Item
                        onClick={() => this.openModal("GenReq")}
                        href="#genreq"
                      >
                        &bull;  Запрос на выпуск сертификата
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        onClick={() => this.openModal("VerifyCert")}
                        href="#verify_cert"
                      >
                        &bull; Проверка</NavDropdown.Item>
                      <NavDropdown.Item
                        href="#create_cert"
                        onClick={() => this.openModal("CreateCert")}
                      >
                        &bull; Генерация</NavDropdown.Item>

                    </NavDropdown>
                  </Dropdown>

                  <Dropdown
                    drop="right">

                    <NavDropdown title="Шифрование">
                      <NavDropdown.Item
                        onClick={() => this.openModal("Encryption")}
                        href="#encrtypt"
                      >
                        &bull; Зашифровать</NavDropdown.Item>
                      <NavDropdown.Item
                        href="#decrypt_data"
                        onClick={() => this.openModal("Decryption")}
                      >
                        &bull; Расшифровать</NavDropdown.Item>
                    </NavDropdown>
                  </Dropdown>
                  <Dropdown drop="right">
                    <NavDropdown title="Подпись (ЭЦП)">
                      <NavDropdown.Item
                        onClick={() => this.openModal("VerifySign")}
                        href="#verify_sign"
                      >
                        &bull; Проверка</NavDropdown.Item>
                      <NavDropdown.Item href="#create_sign"
                        onClick={() => this.openModal("CreateSign")}
                      >
                        &bull; Генерация</NavDropdown.Item>

                    </NavDropdown>
                  </Dropdown>

                </NavDropdown>
              </Navbar>
            </li>

          </ul>
        </nav>
        {
          window.location.pathname === '/' &&
          <React.Fragment>
            {
              this.state.isOpenDescription ?
                <div style={{ borderTop: "1px solid white", width: '100%' }}>
                  <Description />
                </div> : null
            }
            {
              this.state.isOpenDownloadPage ?
                <div style={{ borderTop: "1px solid white", width: '100%' }}>
                  <DownloadPage />
                </div> : null
            }
          </React.Fragment>
        }


        <ModalView
          idView={this.state.idView}
          modalIsOpen={this.state.modalIsOpen}
          afterOpenModal={this.afterOpenModal}
          closeModal={this.closeModal}
          style={
            this.state.viewName === "VerifyCert" ||
              this.state.viewName === "VerifySign" ||
              this.state.viewName === "GenPrivKey" ||
              this.state.viewName === "GenReq" ||
              this.state.viewName === "Encryption" ||
              this.state.viewName === "Decryption" ||
              this.state.viewName === "KeyProtectView" ||
              this.state.viewName === "KeyUnprotectView" ||
              this.state.viewName === "SetPrivateKeyView" ||
              this.state.viewName === "Mac" ||
              this.state.viewName === "GenEncryptKeyView" ||
              this.state.viewName === "Hmac" ||
              this.state.viewName === "CreateToken" ||
              this.state.viewName === "DecodeToken" ||
              this.state.viewName === "CreateCRL" ||
              this.state.viewName === "VerifyCRL" ||
              this.state.viewName === "CreateCert"
              ? customStyleforCertSign
              : noticeStyle
          }
          Content={() => {
            if (this.state.viewName === "Hash") {
              return <Hash />;
            }
            if (this.state.viewName === "Encryption") {
              return <Encryption />;
            }
            if (this.state.viewName === "SetPrivateKeyView") {
              return <SetPrivateKeyView />;
            }
            if (this.state.viewName === "KeyProtectView") {
              return <KeyProtectView />;
            }
            if (this.state.viewName === "KeyUnprotectView") {
              return <KeyUnprotectView />;
            }
            if (this.state.viewName === "Decryption") {
              return <Decryption />;
            }
            if (this.state.viewName === "GenEncryptKeyView") {
              return <GenEncryptKeyView />;
            }
            if (this.state.viewName === "VerifyCert") {
              return <VerifyCert />;
            }
            if (this.state.viewName === "CreateToken") {
              return <CreateToken />;
            }
            if (this.state.viewName === "DecodeToken") {
              return <DecodeToken />;
            }
            if (this.state.viewName === "VerifySign") {
              return <VerifySign />;
            }
            if (this.state.viewName === "CreateSign") {
              return <CreateSign />;
            }
            if (this.state.viewName === "GenPrivKey") {
              return <GenPrivKey />;
            }
            if (this.state.viewName === "Hmac") {
              return <Hmac />;
            }
            if (this.state.viewName === "Mac") {
              return <Mac />;
            }
            if (this.state.viewName === "GenReq") {
              return <GenReq />;
            }
            if (this.state.viewName === "CreateCert") {
              return <CreateCert />;
            }
            if (this.state.viewName === "CreateCRL") {
              return <CreateCRL />;
            }
            if (this.state.viewName === "VerifyCRL") {
              return <VerifyCRL />;
            }
            return null;
          }}
        />

      </header >
    );
  }
}

export default Header;
